import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Helmet } from 'react-helmet'
import { IndexSiteMetadataQuery } from 'generated/types/gatsby'
import Header from '../header/Header'
import Search from '../search/Search'
import { Footer } from '../footer/Footer'
import { Scrollbars } from 'react-custom-scrollbars'
import '../layout/layout.scss'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { TopNav } from '../top-nav/TopNav'
import { LeftNav } from '../left-nav/LeftNav'

interface IndexLayoutProps {
  readonly children?: React.ReactNode | readonly React.ReactNode[]
}

export const IndexLayout = ({ children }: IndexLayoutProps) => {
  const data = useStaticQuery<IndexSiteMetadataQuery>(graphql`
    query IndexSiteMetadata {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)

  const breakpoints = useBreakpoint()
  const [menuState, setMenuState] = useState(false)

  return (
    <main className={`la-page la-page_home${menuState ? ' la-page_has-active-menu' : ''}`}>
      <Helmet
        titleTemplate={`%s - ${data.site.siteMetadata.title}`}
        defaultTitle={data.site.siteMetadata.title}
        meta={[
          {
            name: 'description',
            content: data.site.siteMetadata.description,
          },
          {
            name: 'keywords',
            content: 'LiveAction, LiveNX, Omnipeek, Documentation',
          },
        ]}
      />

      <Header
        title={data.site.siteMetadata.title}
        toggleMenu={() => {
          setMenuState(menuState === undefined ? true : !menuState)
        }}
      >
        {breakpoints.sm && breakpoints.portrait ? <Search autoHeightMax={'50vh'} /> : null}
      </Header>

      {!(breakpoints.sm || (breakpoints.md && breakpoints.portrait)) ? <TopNav /> : null}

      <Scrollbars className={'la-page-body la-scrollbar'}>
        <div className="la-page-body__main">
          {!(breakpoints.sm && breakpoints.portrait) ? (
            <div className={'la-page-body__main-top-panel'}>
              <Search autoHeightMax={'50vh'} />
            </div>
          ) : null}

          <div className="la-page-body__main-content">{children}</div>
          <Footer />
        </div>
      </Scrollbars>

      <button
        className="la-menu-overlay"
        onClick={() => {
          setMenuState(false)
        }}
      />

      {breakpoints.sm || breakpoints.md ? (
        <Scrollbars className="la-left-nav-wrapper la-scrollbar">
          <LeftNav />
        </Scrollbars>
      ) : null}
    </main>
  )
}
